
export const gradesList = [
  { group: 'Undergraduate', options: [
    { label: 'Year 1 (UG-Year 1)', value: 'Year 1 (UG-Year 1)' },
    { label: 'Year 2 (UG-Year 2)', value: 'Year 2 (UG-Year 2)' },
    { label: 'Year 3 (UG-Year 3)', value: 'Year 3 (UG-Year 3)' },
    { label: 'Year 4 (UG-Year 4)', value: 'Year 4 (UG-Year 4)' },
    { label: 'Year 5 (UG-Year 5)', value: 'Year 5 (UG-Year 5)' },
  ]},
  { group: 'Postgraduate', options: [
    { label: 'Masters Degree (PG-MSc)', value: 'Masters Degree (PG-MSc)' },
    { label: 'Fellowships & Medical Licensing Exams (PG - X)', value: 'Fellowships & Medical Licensing Exams (PG - X)' },
  ]},
]; 